
import { useState } from 'react';

export default function Home() {
  const [activeTab, setActiveTab] = useState('development');

  const developmentProjects = [
    {
      id: 1,
      title: "Is There No Place On Earth For Me",
      genre: "Dark Comedy / Drama",
      director: "John Turturro",
      status: "In Development",
      description: "A woman braves the labyrinthine maze of mental health treatment, seeking her true place to belong.",
      image: "https://static.readdy.ai/image/d6f058c9dc9a65b5e5ca9b3b4ff6a6ca/3967a9320ae49363d6d5568314ed91af.jpeg"
    },
    {
      id: 2,
      title: "House of Osuna",
      genre: "Drama",
      status: "Script Development",
      description: "In 18th-century Spain, young royals drive bold progress as the Osuna siblings—one traditional, one progressive—clash, risking their family legacy and the kingdom's future in this darkly humorous drama of power and ambition.",
      image: "https://static.readdy.ai/image/d6f058c9dc9a65b5e5ca9b3b4ff6a6ca/d2bf89f70ca2f10c0eed5b4c505686ed.png"
    },
    {
      id: 3,
      title: "The Summer of Impossible Things",
      genre: "Romantic Drama",
      status: "In Development",
      description: "A woman travels back in time in search for the love her mother denied her.",
      image: "https://static.readdy.ai/image/d6f058c9dc9a65b5e5ca9b3b4ff6a6ca/410e0e6f24ed8baa1c00118a4134b9b3.png"
    }
  ];

  const productionProjects = [
    {
      id: 4,
      title: "A Camera, the Aviator and his Daughter",
      genre: "Drama/Romance",
      director: "Carlota Nelson",
      status: "Principal Photography",
      description: "After her father's death, a filmmaker inherits a cryptic archive of Super 8 films, recordings, and classified documents. A high-ranking U.S. official tied to Cold War espionage, his silent legacy sparks her poetic, emotional quest to understand a man she barely knew.",
      image: "https://static.readdy.ai/image/d6f058c9dc9a65b5e5ca9b3b4ff6a6ca/c3e2ac3fceb8d1e148104b4f28368d96.jpeg"
    }
  ];

  const scrollToAIProject = () => {
    const element = document.getElementById('cinematograficai-section');
    element?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section
        className="relative h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url('https://static.readdy.ai/image/d6f058c9dc9a65b5e5ca9b3b4ff6a6ca/2982fe62e99c450585890ab8eb2e0fc2.jpeg')`
        }}
      >
        <div className="text-center text-white max-w-4xl px-6">
          <h1 className="text-6xl md:text-7xl font-bold mb-6">
            Cinematograficamente Films
          </h1>
          <p className="text-xl md:text-2xl mb-8 leading-relaxed">
            Madrid-based film development and production
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button className="bg-red-600 hover:bg-red-700 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-colors whitespace-nowrap cursor-pointer">
              View Our Projects
            </button>
            <button className="border-2 border-white text-white hover:bg-white hover:text-black px-8 py-4 rounded-lg text-lg font-semibold transition-colors whitespace-nowrap cursor-pointer">
              Get In Touch
            </button>
            <button
              onClick={scrollToAIProject}
              className="relative bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer shadow-lg"
            >
              <span className="flex items-center gap-2">
                Project Cinematografic
                <span className="text-yellow-300 font-black text-xl animate-pulse">AI</span>
                <i className="ri-robot-line text-yellow-300 ml-1"></i>
              </span>
            </button>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="py-20 px-6">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold mb-6 text-gray-900">About Cinematograficamente Films</h2>
              <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                Founded in 2024 by veteran producer Enrique Posner, Cinematograficamente Films has established itself to identify and empower a new generation of Spanish storytellers using traditional and AI-powered audiovisual tools.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CinematograficAI Project Section */}
      <section id="cinematograficai-section" className="py-20 px-6 bg-gradient-to-br from-blue-50 to-purple-50">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-5xl font-bold mb-6 text-gray-900">
              Project Cinematografic<span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-purple-600">AI</span>
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-blue-600 to-purple-600 mx-auto mb-6"></div>
            <p className="text-xl text-gray-700 max-w-3xl mx-auto leading-relaxed">
              Revolutionizing filmmaking through artificial intelligence and cutting‑edge technology
            </p>
          </div>

          <div className="grid lg:grid-cols-2 gap-12 items-center mb-16">
            <div>
              <div className="bg-white rounded-2xl p-8 shadow-xl">
                <div className="flex items-center mb-6">
                  <div className="w-12 h-12 bg-gradient-to-r from-blue-600 to-purple-600 rounded-full flex items-center justify-center mr-4">
                    <i className="ri-brain-line text-white text-xl"></i>
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900">AI-Powered Storytelling</h3>
                </div>
                <p className="text-gray-700 leading-relaxed">
                  AI-driven storytelling is set to upend traditional production techniques, opening vast new worlds and possibilities for everyday storytellers. Stay tuned for more information on our initiative to take advantage of this emerging trend!
                </p>
              </div>
            </div>
            <div className="relative">
              <img
                src="https://static.readdy.ai/image/d6f058c9dc9a65b5e5ca9b3b4ff6a6ca/6f8a8ef28279d8bb2ac0398e3b3f12af.jpeg"
                alt="AI Film Production"
                className="rounded-2xl shadow-xl object-cover w-full h-96"
              />
              <div className="absolute -bottom-6 -right-6 w-24 h-24 bg-gradient-to-r from-blue-600 to-purple-600 rounded-full flex items-center justify-center shadow-lg">
                <i className="ri-robot-2-line text-white text-3xl"></i>
              </div>
            </div>
          </div>

          <div className="grid md:grid-cols-3 gap-8 mb-12">
            <div className="bg-white rounded-xl p-6 shadow-lg text-center hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-gradient-to-r from-blue-100 to-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-lightbulb-line text-2xl text-blue-600"></i>
              </div>
              <h4 className="text-xl font-bold mb-3 text-gray-900">Permissionless Filmmaking</h4>
              <p className="text-gray-600">Itching to tell a story with images? Bypass the gate‑keepers! If you can prompt it, you can tell it!</p>
            </div>
            <div className="bg-white rounded-xl p-6 shadow-lg text-center hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-gradient-to-r from-blue-100 to-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-time-line text-2xl text-purple-600"></i>
              </div>
              <h4 className="text-xl font-bold mb-3 text-gray-900">$Millions to $Thousands</h4>
              <p className="text-gray-600">No money, no problem! Telling your story visually is no longer the domain of the rich. Lack of financing is now the least of your problems!</p>
            </div>
            <div className="bg-white rounded-xl p-6 shadow-lg text-center hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-gradient-to-r from-blue-100 to-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-bar-chart-line text-2xl text-indigo-600"></i>
              </div>
              <h4 className="text-xl font-bold mb-3 text-gray-900">It´s all about story</h4>
              <p className="text-gray-600">In a world of endless stories only the best ones will be found. Make yours one of them!</p>
            </div>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-xl">
            <div className="grid lg:grid-cols-2 gap-8 items-center">
              <div>
                <h3 className="text-3xl font-bold mb-6 text-gray-900">The Future of Audiovisual Storytelling</h3>
                <p className="text-gray-700 leading-relaxed mb-6">
                  Regardless of the status quo, Audiovisual Storytelling is moving from a collaborative art to the single artist. Like writers and painters, now Filmmakers can go solo. Who will create the first one‑man blockbuster?
                </p>
                <div className="flex flex-col sm:flex-row gap-4">
                  <button className="bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white px-6 py-3 rounded-lg font-semibold transition-all whitespace-nowrap cursor-pointer">
                    Stay Tuned!
                  </button>
                </div>
              </div>
              <div className="relative">
                <img
                  src="https://static.readdy.ai/image/d6f058c9dc9a65b5e5ca9b3b4ff6a6ca/e3c7a361f71fbdacfab4d11f82f44dcd.png"
                  alt="AI Collaboration"
                  className="rounded-xl shadow-lg object-cover w-full h-64"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Projects Section */}
      <section className="py-20 px-6 bg-gray-50">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold mb-4 text-gray-900">Our Projects</h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              We´re still suckers for Filmmaking the old fashioned way. This is what we´re working on!
            </p>
          </div>

          {/* Project Tabs */}
          <div className="flex justify-center mb-12">
            <div className="bg-white rounded-full p-1 shadow-lg">
              <button
                onClick={() => setActiveTab('development')}
                className={`px-6 py-3 rounded-full font-semibold transition-colors whitespace-nowrap cursor-pointer ${
                  activeTab === 'development'
                    ? 'bg-red-600 text-white'
                    : 'text-gray-600 hover:text-gray-900'
                }`}
              >
                In Development
              </button>
              <button
                onClick={() => setActiveTab('production')}
                className={`px-6 py-3 rounded-full font-semibold transition-colors whitespace-nowrap cursor-pointer ${
                  activeTab === 'production'
                    ? 'bg-red-600 text-white'
                    : 'text-gray-600 hover:text-gray-900'
                }`}
              >
                In Production
              </button>
            </div>
          </div>

          {/* Project Grid */}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {(activeTab === 'development' ? developmentProjects : productionProjects).map((project) => (
              <div key={project.id} className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow cursor-pointer">
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-48 object-cover object-top"
                />
                <div className="p-6">
                  <div className="flex justify-between items-start mb-3">
                    <h3 className="text-xl font-bold text-gray-900">{project.title}</h3>
                    <span className="bg-red-100 text-red-600 px-2 py-1 rounded text-sm font-medium whitespace-nowrap">
                      {project.status}
                    </span>
                  </div>
                  <p className="text-gray-600 mb-2 font-medium">{project.genre}</p>
                  <p className="text-gray-700 mb-3 text-sm leading-relaxed">{project.description}</p>
                  <div className="text-sm text-gray-600">
                    {project.director && (
                      <p><span className="font-medium">Director:</span> {project.director}</p>
                    )}
                    {project.location && (
                      <p><span className="font-medium">Location:</span> {project.location}</p>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="py-20 px-6 bg-gray-50">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold mb-4 text-gray-900">Founder</h2>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-white rounded-lg shadow-lg overflow-hidden text-center">
              <img
                src="https://static.readdy.ai/image/d6f058c9dc9a65b5e5ca9b3b4ff6a6ca/21d32ec0bf1e784dc1f73c1db7bab1cf.png"
                alt="Enrique Posner"
                className="w-full h-64 object-cover object-top"
              />
              <div className="p-6">
                <h3 className="text-xl font-bold mb-2 text-gray-900">Enrique Posner</h3>
                <p className="text-red-600 font-medium mb-3">Founder &amp; Executive Producer</p>
                <p className="text-gray-600 text-sm">
                  Enrique began as a coffee boy for Tom Hanks. He produced Almodóvar's High Heels and Tie Me Up, Tie Me Down. Independently he produced films like Uncovered and Metroland. As Warner Bros. Spain's Managing Director, he oversaw distribution in Spain for 130+ films, including Harry Potter and The Matrix. Posner co‑founded 6 Sales, handling sales for 50+ films, and produced the Oscar‑nominated animated short The Lady and the Reaper. Recently, he produced The Healer and the documentary Brain Matters.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-20 px-6">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl font-bold mb-6 text-gray-900">Let's Create Something Amazing</h2>
          <p className="text-lg text-gray-600 mb-8 max-w-2xl mx-auto">
            Have a story? We'd love to hear about your project and explore how we can bring it to life together.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button className="bg-red-600 hover:bg-red-700 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-colors whitespace-nowrap cursor-pointer">
              Get In Touch
            </button>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12 px-6">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-3 gap-8">
            <div>
              <h3 className="text-xl font-bold mb-4">StoryForge</h3>
              <p className="text-gray-400 mb-4">
                Creating compelling stories that captivate audiences worldwide.
              </p>
              <div className="flex space-x-4">
                <i className="ri-facebook-fill text-xl hover:text-red-400 cursor-pointer transition-colors"></i>
                <i className="ri-twitter-fill text-xl hover:text-red-400 cursor-pointer transition-colors"></i>
                <i className="ri-instagram-line text-xl hover:text-red-400 cursor-pointer transition-colors"></i>
                <i className="ri-linkedin-fill text-xl hover:text-red-400 cursor-pointer transition-colors"></i>
              </div>
            </div>
            <div>
              <h4 className="text-lg font-semibold mb-4">Projects</h4>
              <ul className="space-y-2 text-gray-400">
                <li><a href="#" className="hover:text-white transition-colors cursor-pointer">In Development</a></li>
                <li><a href="#" className="hover:text-white transition-colors cursor-pointer">In Production</a></li>
              </ul>
            </div>
            <div>
              <h4 className="text-lg font-semibold mb-4">Contact</h4>
              <ul className="space-y-2 text-gray-400">
                <li>Claudio Coello, 22</li>
                <li>Madrid 28001 Spain</li>
                <li>Phone: +34 649 96 27 96</li>
                <li>Email: cinemamentefilms@gmail.com</li>
              </ul>
            </div>
          </div>
          <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
            <p>&copy; 2024 Cinematograficamente Films. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}
